export const HERO_TYPOGRAPHY_WORDMARK_VIEWBOX = {
	width: 904,
	height: 346,
} as const;

export type ScribbleEaseName = 'linear' | 'ease-in' | 'ease-out' | 'ease-in-out' | 'back-out';

export type LetterIntroStyle = 'appear' | 'fade-in' | 'fade-in-blur';
